// 21.12.18
// This contains our theme information -- we can reuse this information
// when creating styles -- see the styles folder
import { createMuiTheme } from "@material-ui/core/styles";
import {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  PRIMARY_COLOR_DARK,
  PRIMARY_COLOR_LIGHT,
  ERROR_COLOR,
} from "./constants/color";

const theme = createMuiTheme({
  palette: {
    primary: {
      // This sets the primary color for the theme
      // see https://material-ui.com/customization/themes/
      main: `${PRIMARY_COLOR}`,
      dark: `${PRIMARY_COLOR_DARK}`,
      light: `${PRIMARY_COLOR_LIGHT}`,
    },
    secondary: {
      main: `${SECONDARY_COLOR}`,
    },
    error: {
      main: `${ERROR_COLOR}`,
    },
  },
  overrides: {
    MuiTab: {
      root: {
        color: `${SECONDARY_COLOR} !important`,
      },
    },
    MuiSelect: {
      root: {
        color: `black !important`,
      },
    },
    MuiButton: {
      root: {
        color: `${SECONDARY_COLOR} !important`,
      },
    },
    MuiCheckbox: {
      root: {
        color: `${PRIMARY_COLOR} !important`,
        padding: "0 !important",
      },
    },
    MuiInput: {
      underline: {
        "&:after": {
          borderBottom: `2px solid ${PRIMARY_COLOR}`,
        },
        "&:before": {
          borderBottom: "1px solid #aaaaaa",
        },
        "&:hover": {
          borderBottom: "transparent !important",
          borderBottomColor: "transparent !important",
        },
        "&:hover:not($disabled):before": {
          backgroundColor: "transparent !important",
          borderBottom: "1px solid #aaaaaa !important",
          borderColor: "#aaaaaa !important",
          color: "none !important",
        },
      },
    },
    MuiRadio: {
      root: {
        color: "#1CABE2 !important",
      },
    },
    MuiSwitch: {
      // bar: {
      //   backgroundColor: '#ccc !important'
      // },
      root: {
        "&$checked": {
          color: `${PRIMARY_COLOR} !important`,
        },
      },
    },
  },
});

export default theme;
